<template>
	<section class="marketing-section bg-color-content-primary px-100-smo bg-img-connect-api">
		<div class="container display-flex align-items-center flex-direction-column-smo gap-500-md gap-600-lg">
			<div class="col-8-md">
				<span class="overline body-md text-color-gray-20">For developers</span>
				<h2 class="mt-50 heading-xxl text-color-white">Get set up</h2>
				<p class="mt-150 text-color-white body-lg"
					>Fundrise's Connect API is organized around REST. Our API has predictable resource-oriented URLs,
					accepts form-encoded request bodies, returns JSON-encoded responses, and uses standard HTTP response
					codes, authentication, and verbs.</p
				>
				<p class="mt-150 text-color-white body-lg"
					>You can use the Connect API in test mode, and it won't affect your live data or interact with your
					custodian or other related third parties.</p
				>
			</div>
			<div class="mt-300 width-100-smo col-6-mdo col-4-lg">
				<BaseLink
					:link="fundriseConnectDocsLink"
					classes="p-100 display-flex align-items-center justify-content-space-between text-color-white for-developers__link"
				>
					<p class="heading-5 no-wrap"> View API documentation </p>
					<BaseSvgIcon name="chevron" class="ml-100" dir="right" height="24" width="24" />
				</BaseLink>

				<BaseLink
					:link="contactLink"
					classes="mt-200 p-100 display-flex align-items-center justify-content-space-between text-color-white for-developers__link"
				>
					<p class="heading-5">{{ contactLink.text }}</p>
					<BaseSvgIcon name="chevron" class="ml-100" dir="right" height="24" width="24" />
				</BaseLink>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { fundriseConnectDocsLink } from '@constants/links';
import { Link } from 'types/layout';

const contactLink: Link = {
	text: 'Request Sandbox access',
	router: 'connect-api-contact'
};
</script>

<style lang="scss">
@use '../../../styles/constants/colors.scss' as *;
@use 'sass:map';

.for-developers {
	&__link {
		border-radius: 4px;
		border: 1px solid token('content-tertiary');

		&:hover {
			color: map.get($brand-colors, 'white');
			background-color: map.get($brand-colors, 'content-primary');
			border: 1px solid map.get($brand-colors, 'white');
		}
	}
}
</style>
